/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import {
  ClickableComponent,
  Flexbox,
  FontAwesomeIcon,
} from '@schoolinks/ui-components';
import cn from 'classnames';
import { unescape } from 'lodash';
import { shape, func, bool } from 'prop-types';
import { withState } from 'recompose';

import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

import Portal from '@mui/material/Portal';

import MobileInterrupt from 'components/Common/LayoutV2/SideNav/MobileSideNav/ResponsivePrompt';
import withRouter from 'containers/withRouter';
import withMediaInfo from 'HOC/withMediaInfo';
import { RouterPropTypes } from 'propTypes/RouterPropTypes';
import dayjs from 'services/dayjs';

import { downloadFile } from 'utils/links';

import RenderAvatar from 'modules/Notifications/components/NotificationItem/RenderAvatar';
import redirectLinkMapping, {
  DISABLED_ON_MOBILE_MAP,
} from 'modules/Notifications/utils';

import s from './NotificationItem.css';

const replaceStringWithEmphasis = (message, emphasis) => {
  const arr = message.split(emphasis);

  return (
    <>
      <span>{unescape(arr[0])}</span>
      <span className={s.highlight}>{emphasis}</span>
      <span>{unescape(arr[1])}</span>
    </>
  );
};

@withMediaInfo()
@withRouter
@withState('showMobileInterrupt', 'setShowMobileInterrupt', false)
export default class NotificationItem extends Component {
  render() {
    const { className, showMobileInterrupt, setShowMobileInterrupt } =
      this.props;
    const {
      router: { navigate },
      notification,
      markNotificationRead,
      mediaInfo: { isMobile },
    } = this.props;
    const {
      notificationType,
      message,
      read,
      created,
      extra: { emphasis, relativeUrl, downloadUrl, ...rest },
    } = notification;
    const getLink = redirectLinkMapping[notificationType];
    let link = typeof getLink === 'function' ? getLink(rest) : undefined;
    link = link || relativeUrl || downloadUrl;
    const shouldInterrupt =
      isMobile && DISABLED_ON_MOBILE_MAP[notificationType];
    return (
      <>
        <ClickableComponent
          onClick={() => {
            if (shouldInterrupt) {
              setShowMobileInterrupt(true);
            } else {
              if (!read) markNotificationRead();
              if (link && !downloadUrl) navigate(link);
              if (downloadUrl) downloadFile(downloadUrl);
            }
          }}
          className={cn(className, s.root, {
            [s.unread]: !read,
            [s.initialCursor]: read && !link,
          })}
        >
          <RenderAvatar notification={notification} />
          <div className={s.content}>
            <Flexbox className={s.paragraph} columnGap={2}>
              <div>{replaceStringWithEmphasis(message, emphasis)}</div>
              <FontAwesomeIcon
                role="img"
                aria-label={read ? 'read' : 'unread'}
                title={read ? 'read' : 'unread'}
                icon={read ? faCircleCheck : faCircleExclamation}
                color="grayDark"
              />
            </Flexbox>
            <Flexbox
              alignItems="center"
              justifyContent="space-between"
              className={s.created}
              columnGap={0.5}
            >
              {dayjs(created).fromNow()}
            </Flexbox>
          </div>
        </ClickableComponent>
        {showMobileInterrupt && (
          <Portal>
            <MobileInterrupt onCancel={() => setShowMobileInterrupt(false)} />
          </Portal>
        )}
      </>
    );
  }
}

NotificationItem.propTypes = {
  notification: shape({}),
  markNotificationRead: func.isRequired,
  mediaInfo: shape({
    isMobile: bool,
    isTablet: bool,
    isDesktop: bool,
  }).isRequired,
  router: RouterPropTypes.isRequired,
};

NotificationItem.defaultProps = {
  notification: {
    notificationType: '',
    message: '',
    read: false,
  },
};
